<div class="modal-header color-primario-fondo text-white">
    <h4 class="modal-title">Confirmación</h4>
    <button type="button" class="btn btn-primary color-secundario-fondo" aria-label="Close" (click)="onClickDismiss($event,'Modal cerrado')">Cerrar</button>
</div>
<div class="modal-body text-center">
    <i class="bi bi-question-square-fill icono-confirmacion"></i>
    <h5 class="py-3">{{mensaje}}</h5>
</div>
<div class="modal-footer text-center">
    <button type="button" class="btn btn-success" (click)="onClickClose($event, true)">Aceptar</button>
    <button type="button" class="btn btn-danger" (click)="onClickClose($event, false)">Cancelar</button>
</div>
